import { defineStore } from 'pinia';
import { subscribe } from '@nextcloud/event-bus';
import logger from '../logger';
import Vue from 'vue';
export const useFilesStore = function (...args) {
    const store = defineStore('files', {
        state: () => ({
            files: {},
            roots: {},
        }),
        getters: {
            /**
             * Get a file or folder by id
             */
            getNode: (state) => (id) => state.files[id],
            /**
             * Get a list of files or folders by their IDs
             * Does not return undefined values
             */
            getNodes: (state) => (ids) => ids
                .map(id => state.files[id])
                .filter(Boolean),
            /**
             * Get a file or folder by id
             */
            getRoot: (state) => (service) => state.roots[service],
        },
        actions: {
            updateNodes(nodes) {
                // Update the store all at once
                const files = nodes.reduce((acc, node) => {
                    if (!node.fileid) {
                        logger.error('Trying to update/set a node without fileid', node);
                        return acc;
                    }
                    acc[node.fileid] = node;
                    return acc;
                }, {});
                Vue.set(this, 'files', { ...this.files, ...files });
            },
            deleteNodes(nodes) {
                nodes.forEach(node => {
                    if (node.fileid) {
                        Vue.delete(this.files, node.fileid);
                    }
                });
            },
            setRoot({ service, root }) {
                Vue.set(this.roots, service, root);
            },
            onDeletedNode(node) {
                this.deleteNodes([node]);
            },
            onCreatedNode(node) {
                this.updateNodes([node]);
            },
            onUpdatedNode(node) {
                this.updateNodes([node]);
            },
        },
    });
    const fileStore = store(...args);
    // Make sure we only register the listeners once
    if (!fileStore._initialized) {
        subscribe('files:node:created', fileStore.onCreatedNode);
        subscribe('files:node:deleted', fileStore.onDeletedNode);
        subscribe('files:node:updated', fileStore.onUpdatedNode);
        fileStore._initialized = true;
    }
    return fileStore;
};
